<template>
  <div class="header">
        <nav class="content">
            <div class="pcheaderBackground" style="display:none">
                <div class="headerContent">
                    <img @click="goHome" src="../assets/headerLogo.svg"/>
                    <Icon @click="model =true" type="md-menu" size="35" class="menu"/>
                    <ul class="menuUl">
                        <!-- <li class="menuLi" @click="goHome">Home</li> -->
                        <li class="menuLi" @click="goProducts">Products</li>
                        <li class="menuLi">
                            <Dropdown @on-click="goCountry">
                                <a href="javascript:void(0)">
                                    Service Coverage Regions
                                    <Icon type="ios-arrow-down"></Icon>
                                </a>
                                <DropdownMenu slot="list">
                                    <div>
                                    <DropdownItem name="mexico" style="display:inline-block;font-size:16px !important;">Mexico</DropdownItem>
                                    <DropdownItem name="vietnam" style="display:inline-block;font-size:16px !important;">Vietnam</DropdownItem>
                                    </div>
                                    <div>
                                    <DropdownItem name="brazil" style="display:inline-block;font-size:16px !important;">Brazil</DropdownItem>
									<DropdownItem name="kenya" style="display:inline-block;font-size:16px !important;">Kenya</DropdownItem>
                                    </div>
                                    <div>
                                    <DropdownItem name="colombia" style="display:inline-block;font-size:16px !important;">Colombia</DropdownItem>
                                    <DropdownItem name="indonesia" style="display:inline-block;font-size:16px !important;">Indonesia</DropdownItem>
                                    </div>
                                    <!-- <div>
                                    <DropdownItem name="peru" style="display:inline-block">Peru</DropdownItem>
																		<DropdownItem name="philipines" style="display:inline-block;font-size:16px !important;">Philipines</DropdownItem>
                                    <DropdownItem name="iraq" style="display:inline-block;font-size:16px !important;">Iraq</DropdownItem>
                                    </div> -->
                                    <div>
                                    <DropdownItem name="argentina" style="display:inline-block;font-size:16px !important;">Argentina</DropdownItem>
                                    <DropdownItem name="turkey" style="display:inline-block;font-size:16px !important;">Turkey</DropdownItem>
                                    </div>
                                    <div>
                                    <DropdownItem name="nigeria" style="display:inline-block;font-size:16px !important;">Nigeria</DropdownItem>
                                    <DropdownItem name="chile" style="display:inline-block;font-size:16px !important;">Chile</DropdownItem>
                                    <!-- <DropdownItem name="bangladesh" style="display:inline-block;font-size:16px !important;">Bangladesh</DropdownItem> -->
                                    </div>
                                    <div>
                                    <DropdownItem name="egypt" style="display:inline-block;font-size:16px !important;">Egypt</DropdownItem>
                                    <DropdownItem name="thailand" style="display:inline-block;font-size:16px !important;">Thailand</DropdownItem>
                                    </div>
                                    <div>
                                    <DropdownItem name="pakistan" style="display:inline-block;font-size:16px !important;">Pakistan</DropdownItem>
                                    </div>
                                    <!-- <DropdownItem name="india" style="font-size:16px !important;">India</DropdownItem> -->
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                        <li class="menuLi" @click="goAboutUs">About us</li>
                        <li class="menuLi" @click="goContactUs">Contact us</li>
                    </ul>
                </div>
            </div>
            <div class="header">
                <img @click="goHome" src="../assets/headerLogo.svg"/>
                <Icon @click="model =true" type="md-menu" size="35" class="menu"/>
                <ul class="menuUl">
                    <!-- <li class="menuLi" @click="goHome">Home</li> -->
                    <li class="menuLi" @click="goProducts">Products</li>
                    <li class="menuLi">
                        <Dropdown @on-click="goCountry">
                            <a href="javascript:void(0)">
                               Service Coverage Regions
                                <Icon type="ios-arrow-down"></Icon>
                            </a>
                            <DropdownMenu slot="list">
                                <div>
                                <DropdownItem name="mexico" style="display:inline-block;font-size:16px !important;">Mexico</DropdownItem>
                                <DropdownItem name="vietnam" style="display:inline-block;font-size:16px !important;">Vietnam</DropdownItem>
                                </div>
                                <div>
                                <DropdownItem name="brazil" style="display:inline-block;font-size:16px !important;">Brazil</DropdownItem>
								<DropdownItem name="kenya" style="display:inline-block;font-size:16px !important;">Kenya</DropdownItem>
                               
                                </div>
                                <div>
                                <DropdownItem name="colombia" style="display:inline-block;font-size:16px !important;">Colombia</DropdownItem>
                                <DropdownItem name="indonesia" style="display:inline-block;font-size:16px !important;">Indonesia</DropdownItem>
                                </div>
                               <!-- <div>
                                <DropdownItem name="peru" style="display:inline-block">Peru</DropdownItem>
                                 <DropdownItem name="philipines" style="display:inline-block;font-size:16px !important;">Philipines</DropdownItem>
                                <DropdownItem name="iraq" style="display:inline-block;font-size:16px !important;">Iraq</DropdownItem>
                                </div> -->
                                <div>
                                <DropdownItem name="argentina" style="display:inline-block;font-size:16px !important;">Argentina</DropdownItem>
                                <DropdownItem name="turkey" style="display:inline-block;font-size:16px !important;">Turkey</DropdownItem>
                                </div>
                                <div>
                                <DropdownItem name="nigeria" style="display:inline-block;font-size:16px !important;">Nigeria</DropdownItem>
                                <DropdownItem name="chile" style="display:inline-block;font-size:16px !important;">Chile</DropdownItem>
                                <!-- <DropdownItem name="bangladesh" style="display:inline-block;font-size:16px !important;">Bangladesh</DropdownItem> -->
                                </div>
                                <div>
                                <DropdownItem name="egypt" style="display:inline-block;font-size:16px !important;">Egypt</DropdownItem>
                                <DropdownItem name="thailand" style="display:inline-block;font-size:16px !important;">Thailand</DropdownItem>
                                </div>
                                <div>
                                <DropdownItem name="pakistan" style="display:inline-block;font-size:16px !important;">Pakistan</DropdownItem>
                                </div>
                                <!-- <DropdownItem name="india" style="font-size:16px !important;">India</DropdownItem> -->
                            </DropdownMenu>
                        </Dropdown>
                    </li>
                    <li class="menuLi" @click="goAboutUs">About us</li>
                    <li class="menuLi" @click="goContactUs">Contact us</li>
                </ul>
            </div>
        </nav>
        <Drawer width='70' v-model="model" :closable="false">
            <div slot="header">
                <img @click="goHome" class="menuHeaderLogo" src="../assets/headerLogo.png"/>
            </div>
            <div style="margin-top:0px;">
                <!-- <div @click="goHome" style="padding-bottom: 18px;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">Home</div> -->
                <div @click="goProductsMobile" style="padding: 18px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">Products</div>
                <div style="padding: 10px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">
                    <Collapse simple>
                        <Panel name="1">
                            Service Coverage Regions
                            <p slot="content" class="mobilCountryList">
                                <ul>
                                    <li>
                                        <p @click="goCountry('mexico')">Mexico</p>
                                        <p @click="goCountry('nigeria')">Nigeria</p>
										<p @click="goCountry('thailand')">Thailand</p>
                                        <!-- <p @click="goCountry('philipines')">Philipines</p> -->
                                    </li>
                                    <li>
                                        <p @click="goCountry('brazil')">Brazil</p>
                                        <p @click="goCountry('egypt')">Egypt</p>
                                        <p @click="goCountry('indonesia')">Indonesia</p>
                                    </li>
                                    <li>
                                        <p @click="goCountry('colombia')">Colombia</p>
                                        <p @click="goCountry('pakistan')">Pakistan</p>
                                        <p @click="goCountry('kenya')">Kenya</p>
                                    </li>
                                    <li>
                                        <!-- <p @click="goCountry('india')">India</p> -->
                                        <p @click="goCountry('argentina')">Argentina</p>
                                        <p @click="goCountry('vietnam')">Vietnam</p>
                                        <p @click="goCountry('chile')">Chile</p>
                                    </li>
                                    <li>
                                        <!-- <p @click="goCountry('iraq')">Iraq</p> -->
										<p @click="goCountry('chile')">Chile</p>
                                        <p @click="goCountry('turkey')">Turkey</p>
                                        <p @click="goCountry('thailand')">Thailand</p>
                                        <!-- <p @click="goCountry('bangladesh')">Bangladesh</p> -->
                                    </li>
                                   <!-- <li>
                                    </li> -->
                                </ul>
                            </p>
                        </Panel>
                    </Collapse>
                </div>
                <div @click="goAboutUsMobile" style="padding: 18px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">About us</div>
                <div @click="goContactUs" style="padding: 18px 0;border-bottom: 1px solid rgba(245, 246, 252, 0.2);">Contact us</div>
            </div>
            
        </Drawer>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
        model:false
    }
  },
  methods:{
      goContactUs(){
          this.$router.push('/contact')
          window.scrollTo(0, 0)
      },
      goHome(){
          this.model = false
          window.scrollTo(0, 0)
          this.$router.push('/')
      },
      goProducts(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 700)
            }, 100)
          this.$router.push('/')
      },
      goProductsMobile(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 300)
            }, 100)
          this.$router.push('/')
      },
      goAboutUs(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 3850)
            }, 100)
          this.$router.push('/')
      },
      goAboutUsMobile(){
          this.model = false
            setTimeout(() => {
                window.scrollTo(0, 4350)
            }, 100)
          this.$router.push('/')
      },
      goCountry(name){
          this.$router.push('/'+name)
          window.scrollTo(0, 0)
      }
  },
  created() {
    $(window).scroll(function() {
      let topp = $(document).scrollTop();
      if (topp < 40) {
        // 恢复正常流并且瞬间隐藏
        $(".pcheaderBackground").css({
          opacity: 0,
          "pointer-events": "none"
        });
      } else {
        // 先让盒子固定定位在顶部然后下拉
        $(".pcheaderBackground")
          .css({
            opacity: 1,
            position: "fixed",
            top: 0,
            left: 0,
            zIndex:1000,
            "pointer-events": ""
          })
          .slideDown();
      }
    });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media all and (min-width:960px){
    .header{
        position: relative;
        width: 100%;
        .content{
            color: #FFFFFF;
            // background: rgb(0, 38, 67);
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
            .header{
                width: 80%;
                margin: 0 auto;
                position: relative;
                display: flex;
                padding-bottom: 20px;
                img{
                    width: 210px;
                    height: 42px;
                    margin-top: 18.5px;
                }
                .menu{display: none;}
                .menuUl{
                    position: absolute;
                    right: 0;
                    margin-top: 28.5px;
                    list-style: none;
                    .menuLi{
                        color: #FFFFFF;
                        cursor: pointer;
                        display: inline-block;
                        margin-left: 80px;
                        font-size: 16px;
                        font-family: OpenSans-SemiBold, OpenSans;
                        font-weight: 600;
                    }
                    .menuLi:hover{
                        color: #2d8cf0;
                    }
                    a{
                        color: white;
                    }
                    a:hover{
                        color: #2d8cf0;
                    }
                }
            }
            .pcheaderBackground{
                width: 100%;
                background: rgb(0, 38, 67);
                .headerContent{
                    width: 80%;
                    margin: 0 auto;
                    padding-bottom: 20px;
                    position: relative;
                    display: flex;
                }
                img{
                    width: 210px;
                    height: 42px;
                    margin-top: 18.5px;
                }
                .menu{display: none;}
                .menuUl{
                    position: absolute;
                    right: 0;
                    margin-top: 28.5px;
                    list-style: none;
                    .menuLi{
                        color: #FFFFFF;
                        cursor: pointer;
                        display: inline-block;
                        margin-left: 80px;
                        font-size: 16px;
                        font-family: OpenSans-SemiBold, OpenSans;
                        font-weight: 600;
                    }
                    .menuLi:hover{
                        color: #2d8cf0;
                    }
                    a{
                        color: white;
                    }
                    a:hover{
                        color: #2d8cf0;
                    }
                }
            }
        }
    }
}
@media all and (max-width:960px){
    .header{
        position: relative;
        width: 100%;
        .content{
            color: #FFFFFF;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
            .header{
                margin: 0 18px;
                position: relative;
                display: flex;
                padding-bottom: 20px;
                img{
                    width: 136px;
                    height: 28px;
                    margin-top: 20px;
                }
                .menu{
                    position: absolute;
                    right: 35px;
                    margin-top: 15px;
                }
                .menuUl{
                    display: none;
                }
            }
            .pcheaderBackground{
                width: 100%;
                background: rgb(0, 38, 67);
                .headerContent{
                    margin: 0 18px;
                    position: relative;
                    display: flex;
                    padding-bottom: 20px;
                }
                img{
                    width: 136px;
                    height: 28px;
                    margin-top: 20px;
                }
                .menu{
                    position: absolute;
                    right: -1px;
                    margin-top: 15px;
                }
                .menuUl{
                    display: none;
                }
            }
        }
    }
}
.mobilCountryList{
    ul{
        list-style: none;
        li{
            p{
                display: inline-block;
                width: 31%;
                text-align: left;
                font-size: 11px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color: #fff;
                line-height: 19px;
            }
        }
    }
}
</style>
<style lang="less">
	.header{
		.ivu-select-dropdown{
		    padding: 15px 12px !important;
		}
	}
	
    .menuHeaderLogo{
        width: 136px;
        height: 28px;

    }
    .ivu-drawer-content{
        background-color: rgb(0,38,67) !important;
    }
    .ivu-drawer-close .ivu-icon-ios-close{
        color:white !important;
    }
    .ivu-drawer-header{
        border-bottom:none !important;
        padding: 20px !important;
    }
    .ivu-drawer-body{
        padding: 20px !important;
        color:#F9FAFE !important;
        font-size: 16px  !important;

    }
    .ivu-drawer-close{
        right:20px !important;
        top:20px !important;
    }
    .ivu-dropdown-menu{
        color: #001B37 !important;
    }
    
    .ivu-dropdown-item{
        color: #001B37 !important;
        width: 120px !important;
    }
    .ivu-dropdown-item:hover{
        color: #2d8cf0 !important;
    }
    .ivu-dropdown .ivu-select-dropdown{
        top:55px !important;
    }
    .ivu-collapse-simple{
        background: rgb(0, 38, 67) !important;
    }
    .ivu-collapse-content{
        background: rgb(0, 38, 67) !important;
        color: #fff !important;
        padding:0 !important;
        padding-left:10px !important;
    }
    .ivu-collapse{
        border: 1px solid rgb(0, 38, 67) !important;
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header{
        color: #fff !important;
        padding-left: 0px !important;
    }
    .ivu-collapse>.ivu-collapse-item>.ivu-collapse-header>i{
        float: right !important;
        margin-top: 10px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/header.vue